import React from 'react';
import { mapIndexList } from 'utils/config';
import ChartDongTienRong from '../chart/chartDongTienRong';

import ChartRangeMarket from '../chart/chartRangeMarket';

import * as _ from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ImInfo } from 'react-icons/im';
import { log } from 'utils';

const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`;

function TabDongTien(props) {
  const [topAnhHuong, setTopAnhHuong] = React.useState(null);
  const [intervalId, setIntervalId] = React.useState(null);
  const { marketActive, t, theme } = props;

  // const preMarketActive = usePrevious(marketActive)

  const abortController = new AbortController();

  React.useEffect(() => {
    return () => {
      abortController.abort();
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  React.useEffect(() => {
    let _intervalId;
    if (marketActive) {
      if (intervalId) clearInterval(intervalId);
      loadNganhAnhHuongIndex();

      _intervalId = setInterval(() => {
        loadNganhAnhHuongIndex();
      }, 10 * 1000);

      setIntervalId(_intervalId);
    }

    return () => {
      if (_intervalId) clearInterval(_intervalId);
    };
  }, [marketActive]);

  function loadNganhAnhHuongIndex() {
    fetch(
      appUrl + 'pbapi/api/stockBoard/chart/index/' + mapIndexList[marketActive],
      {
        signal: abortController.signal,
      }
    )
      .then((response) => response.json())
      .then((res) => {
        // // log(res);
        setTopAnhHuong(_.filter(res.data, (o) => o.IndexVolume > 0));
      })
      .catch((error) => {
        log(error);
      });
  }

  return (
    <div
      className="d-grid w-100 h-100"
      style={{
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: '15px',
        alignItems: 'flex-start',
      }}
    >
      <div
        className="w-100"
        style={{ background: theme === 'dark' ? '#110E1E' : '#ffffff', borderRadius: '4px' }}
      >
        <p
          className="text-center mb-0 text-white text-uppercase fz-14 fw-500"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-Market-breadth')} {' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.do-rong-thi-truong')}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartRangeMarket data={topAnhHuong} t={t} theme={theme}/>
        </div>
      </div>
      <div
        className="w-100"
        style={{ background: theme === 'dark' ? '#110E1E' : '#ffffff', borderRadius: '4px' }}
      >
        <p
          className="text-center mb-0 text-white text-uppercase fz-14 fw-500"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-net-money-flow')} {' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.dong-tien-dong')}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartDongTienRong data={topAnhHuong} />
        </div>
      </div>
    </div>
  );
}

export default TabDongTien;
